import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byUserTrack: {}
});

const getSegments = (state, note) => {
    if (state.byUserTrack[note.userTrackId]) {
        state.byUserTrack[note.userTrackId][note._id] = note;
    } else {
        state.byUserTrack[note.userTrackId] = {
            [note._id]: note
        };
    }
};

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case ACTIONS.POST_NOTES: {
            const { note } = action.payload;
            const newState = { ...state };
            getSegments(newState, note);
            return {
                ...newState
            };
        }
        case ACTIONS.GET_NOTES: {
            const { notes } = action.payload;
            const newState = { ...state };
            if (notes.length) {
                notes.forEach((note) => {
                    getSegments(newState, note);
                });
            }
            return {
                ...newState
            };
        }
        default:
            return state;
    }
};
